import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
@Pipe({
    name: 'largeamount'
})
export class LargeAmountPipe implements PipeTransform {
    constructor(private decimalPipe: DecimalPipe) {

    }
    transform(value: any, args?: any): any {
        let decimals = 2;
        const valueStr = String(Math.abs(Math.trunc(value)));
        if (valueStr.length > 4) {
            decimals = 0;
        }
        return this.decimalPipe.transform(value, '1.' + decimals + '-' + decimals);
    }

}
